import React from "react"
import PropertyCalendarRoomCell from "./PropertyCalendarRoomCell"
import PropertyCalendarRoomTypeCell from "./PropertyCalendarRoomTypeCell"

class PropertyCalendarSidebar extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('PropertyCalendarSidebar', this.props);
		var self = this;
		var room_types_and_rooms = [];
		var room_types_count = 0;
		var rooms_count = 0;

		for (var i = 0, ilen = this.props.room_types.length; i < ilen; i++ ) {
			var room_type = this.props.room_types[i];
			room_types_and_rooms.push(<PropertyCalendarRoomTypeCell key={'room_type_' + room_type.id} room_type={room_type} top={this.calculateTop(room_types_count, rooms_count)} onExpandCollapseRoomType={self.props.onExpandCollapseRoomType} />);
			room_types_count++;
			if (room_type.collapsed) {
				// do not display room types
			} else if (room_type.rooms && room_type.rooms.length > 0) {
				for (var j = 0, jlen = room_type.rooms.length; j < jlen; j++) {
					var room = room_type.rooms[j];
					room_types_and_rooms.push(<PropertyCalendarRoomCell key={'room_' + room.id} room={room} top={this.calculateTop(room_types_count, rooms_count)} show_housekeeping={room_type.housekeeping_status == "enabled" ? true : false}/>);
					rooms_count++;
				}
			} else if (room_type.room_groups && room_type.room_groups.length > 0){
        for (var j = 0, jlen = room_type.room_groups.length; j < jlen; j++) {
          var room_group = room_type.room_groups[j];
          room_types_and_rooms.push(<PropertyCalendarRoomCell key={'room_' + room_group.id} room_group={room_group} top={this.calculateTop(room_types_count, rooms_count)} show_housekeeping={room_type.housekeeping_status == "enabled" ? true : false}/>);
          rooms_count++;
        }
      }
		}

		return (
			<div className="PropertyCalendarSidebar">
				{room_types_and_rooms}
			</div>
		);
	}

	calculateTop(room_types_count, rooms_count) {
		return (room_types_count * 80) + (rooms_count * 40);
	}

}

export default PropertyCalendarSidebar